module.exports = __webpack_public_path__ + "static/media/Sharetemplate_Black.48a070bc.svg";